const time = new Date().getTime();
// 週稼働エリア
export const week_area = [{
      code: '09201',
      pref: '栃木県',
      area: '宇都宮市',
      operate: '毎週（月～土）',
      dlimit: '配布前週月曜',
      limit: '1万部／週',
      href: 'data/area_utsunomiya.pdf?v=' + time,
      latlng: { lat: 36.55850063620128, lng: 139.8975110366916 }
    },{
      code: '09203',
      pref: '栃木県',
      area: '栃木市',
      operate: '毎週（月～土）',
      dlimit: '配布前週月曜',
      limit: '1万部／週',
      href: 'data/area_tochigi.pdf?v=' + time,
      latlng: { lat: 36.382312231041126, lng: 139.7338659104417 }
    },{
      code: '09361',
      pref: '栃木県',
      area: '壬生町',
      operate: '毎週（月～土）',
      dlimit: '配布前週月曜',
      limit: '1万部／週',
      href: 'data/area_mibu.pdf?v=' + time,
      latlng: { lat: 36.45795261407607, lng: 139.8071524142844 }
    }]
// 月稼働エリア
export const month_area = [{
      code: '09208',
      pref: '栃木県',
      area: '小山市',
      operate: '毎月2回（1日～15日、16日～月末）',
      dlimit: '配布開始前週月曜',
      limit: '2万部／回',
      href: 'data/area_oyama.pdf?v=' + time,
      latlng: { lat: 36.31048350015549, lng: 139.80115503834503 }
    },{
      code: '09204',
      pref: '栃木県',
      area: '佐野市',
      operate: '毎月2回（1日～15日、16日～月末）',
      dlimit: '配布開始前週月曜',
      limit: '2万部／回※',
      href: 'data/area_sano.pdf?v=' + time,
      latlng: { lat: 36.34940948018275, lng: 139.584938383613}
    },{
      code: '09202',
      pref: '栃木県',
      area: '足利市',
      operate: '毎月2回（1日～15日、16日～月末）',
      dlimit: '配布開始前週月曜',
      limit: '2万部／回※',
      href: 'data/area_ashikaga.pdf?v=' + time,
      latlng: { lat: 36.33251112900741, lng: 139.45558278527653}
    },{
      code: '10203',
      pref: '群馬県',
      area: '桐生市',
      operate: '毎月1回（16日～月末）',
      dlimit: '配布開始前週月曜',
      limit: '2万部／回※',
      href: 'data/area_kiryu.pdf?v=' + time,
      latlng: { lat: 36.41582432144586, lng: 139.32519736458627}
    },{
      code: '10207',
      pref: '群馬県',
      area: '館林市',
      operate: '毎月1回（16日～月末）',
      dlimit: '配布開始前週月曜',
      limit: '2万部／回※',
      href: 'data/area_tatebayashi.pdf?v=' + time,
      latlng: { lat: 36.24363414662627, lng: 139.5353251705175}
    }]
